import { Ruler, Repeat, Sparkles, LayoutList } from "lucide-react";
import Reveal from "./Reveal";

const FACTORS = [
  { icon: Ruler, title: "Size of the space", body: "Square footage or number of rooms — bigger spaces simply take more time." },
  { icon: Repeat, title: "Frequency", body: "One-time cleans cost more per visit than recurring weekly, biweekly or monthly service." },
  { icon: Sparkles, title: "Condition", body: "How much detail work is needed — especially for first-time or deep cleans." },
  { icon: LayoutList, title: "Type of service", body: "Standard, deep, move-in/out, post-construction or commercial — each scopes differently." },
];

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="bg-white py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-24">
          <Reveal>
            <p className="eyebrow">Pricing</p>
            <h2 className="mt-4 font-serif text-4xl tracking-tight text-ink sm:text-5xl">
              Honest quotes, <span className="italic text-ocean">with flat-rate options too</span>
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slateblue">
              Every home and space is different, so we start with a free, no-obligation
              quote that actually reflects your space. And where it makes sense — like
              standard recurring cleans — we're happy to offer simple flat-rate pricing
              too. Either way: honest pricing, no surprises.
            </p>
            <a
              href="#quote"
              data-testid="pricing-quote-button"
              className="mt-8 inline-block rounded-full bg-ocean px-8 py-4 text-sm font-bold uppercase tracking-widest text-salt transition-[background-color,transform] duration-300 hover:bg-seafoam hover:scale-[1.03]"
            >
              Get My Free Quote
            </a>
          </Reveal>

          <div className="grid gap-5 sm:grid-cols-2">
            {FACTORS.map(({ icon: Icon, title, body }, i) => (
              <Reveal
                key={title}
                i={i + 1}
                data-testid={`pricing-factor-${i}`}
                className="rounded-2xl border border-ink/10 bg-salt p-7 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 hover:shadow-[0_20px_50px_-24px_rgba(19,41,61,0.3)]"
              >
                <Icon className="h-6 w-6 text-seafoam" strokeWidth={1.8} />
                <h3 className="mt-4 font-serif text-lg tracking-tight text-ink">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slateblue">{body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
